/**
 * Created by petr on 12.01.15.
 */

// Чтобы отключить преобразование, нужно назначить элементу класс 'no-parse'
// Так же, для указания ширины можно назначить элементу data-width в процентах
window.makeRadiosCheckboxesAndSelectsBeautiful = function makeRadiosCheckboxesAndSelectsBeautiful() {

    $('select').not('.parsed').not('[multiple]').each(function () {
        if ($(this).attr('readonly')) {
            $(this).attr('disabled', 'disabled').after('<input type="hidden" value="' + $(this).val() + '" name="' + $(this).attr('name') + '" />');
        }

        var select = this;

        // Отмена обработки полей уведомления и переноса уведомления
        try{
            if (
                $(select).attr('id') && (
                    !$(select).attr('id').match('^client_notification_') &&
                    !$(select).attr('id').match('^client_newComment_')
                )
            ) {

                var wrap = $('<span class="nice-select">')/*.width($(select).width())*/;
                var text = $('<span class="nice-select-text">').text($(':selected', select).text());

                if ($(select).attr("class") != 'no-parse') {
                    $(select).addClass('parsed');
                }

                $(select).wrap(wrap).before(text);

                // $('span.nice-select').width('100%');

                if ($(select).attr("class") == 'no-parse' && $(select).data('width')) {
                    $(select).parent('span').css('width', $(select).data('width'));
                    // $(select).parent('span').width($(select).data('width'));
                }

                $(select).addClass('parsed');

                $(document).on('change', select, function () {
                    $(text).text($(':selected', select).text());
                });

                // "Актуализация" всех контактов при их создании
                if ($('div.actual-contacts').length) {
                    $('div.actual-contacts input[name$="[actual]"]').prop('checked', true);
                }

                if ($('div#restaurant-group-contacts').length) {
                    $('div#restaurant-group-contacts input[name$="[actual]"]').prop('checked', true);
                }
            }
        }catch(error){
            console.log('=== start ===');
            console.log('Ошибка в азбуке морзе:');
            console.log(error);
            console.log('=== end ===');
        }
    });

    $(':radio,:checkbox').not('.parsed').each(function () {
        var input = this;

        $(input).addClass('parsed');

        if ($(input).parent('div').attr("class") != 'no-parse') {
            $(input).wrap('<div class="nice-' + $(input).attr('type') + '" />');
            $(input).width($(input).parent().width()).height($(input).parent().height());
        } else {
            if ($(input).attr('type') == 'checkbox') {
                $(input).css('-webkit-appearance', 'checkbox');
            } else {
                $(input).css('width', '5%');
                $(input).css('-webkit-appearance', 'radio');
            }
            $(input).css('display', 'inline');
            $(input).parent('div').find('label').css('display', 'inline');
        }

        $(document).on('click', input, function (e) {
            ($(input).is(':checked') ? $(input).parent().addClass('checked') : $(input).parent().removeClass('checked'));

            if ('radio' == $(input).attr('type')) {
                $('[name="' + $(input).attr('name') + '"]').not(input).not(':checked').parent().removeClass('checked');
            }
        });

        ($(input).is(':checked') ? $(input).parent().addClass('checked') : $(input).parent().removeClass('checked'));
    });
};

var newClientFormsHandler = function () {
    $('.tabbed .tabs li.tasks span')
        .css({'marginLeft': ($('.tabbed .tabs li.tasks').width() - $('.tabbed .tabs li.tasks span').outerWidth()) / 2});

    $('.tabbed .tabs li').click(function () {
        window.location.hash = $(this).data('tab');
    });

    $('.tabbed .content').hide();
    $('.tabbed .content:first').show();
    $('.tabbed .tabs li:first').addClass('current');

    /* --------------------------------------- */

    var $clientType = $("#new_client_clientType");
    var $firmType = $("#new_client_firmType");
    var $contractors = $("#new_client_contractors");

    var select2opts = {
        width: '100%',
        placeholder: "Нажмите для выбора"
    };

    $firmType.select2(select2opts);

    $contractors.select2(select2opts);

    var firmTypeChangeHandler = function () {
        if ($clientType.val() == 5) { // Заведения
            $firmType.select2("readonly", false);
            $firmType.select2({"placeholder": "Нажмите для выбора", width: '100%'});
        } else {
            $firmType.select2("readonly", true);
            $firmType.select2("val", false);
            $firmType.select2({"placeholder": "Только для заведений", width: '100%'});
        }
    };

    $clientType.on('change', firmTypeChangeHandler);
    firmTypeChangeHandler();

    /* --------------------------------------- */

}

var clientFormsHandler = function () {
    $('[data-prototype]').each(function () {
        rowsCount[$(this).attr('id')] = $(this).find('.row').not('.row-first').length;
    });

    $('[data-prototype][data-length]').each(function () {
        rowsCount[$(this).attr('id')] = $(this).data('length');
    });

    $('.fancybox-inner .row-add').trigger('click').remove();

    $(".need-click").click();

    if (1 == $('[name="task[clients_select]"]:checked').length) {
        $('[name="task[clients_select]"]:checked').trigger('click');
    } else {
        if ($('[name="task[clients_users]"]').val()) {
            $('[name="task[clients_select]"][value="users"]').trigger('click');
        }

        if ($('[name="task[clients_other]"]').val()) {
            $('[name="task[clients_select]"][value="other"]').trigger('click');
        }
    }

    makeRadiosCheckboxesAndSelectsBeautiful();

    $('.tabbed .tabs li.tasks span')
        .css({'marginLeft': ($('.tabbed .tabs li.tasks').width() - $('.tabbed .tabs li.tasks span').outerWidth()) / 2});

    $('.tabbed .tabs li').click(function () {
        window.location.hash = $(this).data('tab');
    });

    $('.tabbed .content').hide();
    $('.tabbed .content:first').show();
    $('.tabbed .tabs li:first').addClass('current');

    var $clientType = $("#client_clientType");
    var $firmType = $("#client_firmType");
    var $contractors = $("#client_contractors");

    var select2opts = {
        width: '100%',
        placeholder: "Нажмите для выбора"
    };

    $firmType.select2(select2opts);

    $contractors.select2(select2opts);

    var firmTypeChangeHandler = function () {
        if ($clientType.val() == 5) { // Заведения
            $firmType.select2("readonly", false);
            $firmType.select2({"placeholder": "Нажмите для выбора", width: '100%'});
        } else {
            $firmType.select2("readonly", true);
            $firmType.select2("val", false);
            $firmType.select2({"placeholder": "Только для заведений", width: '100%'});
        }
    };

    $clientType.on('change', firmTypeChangeHandler);
    firmTypeChangeHandler();

    /* --------------------------------------- */

    var suggestField = 0;

    $('.suggest').remove();

    $suggest = $('<ul>');

    $suggest
        .addClass('suggest')
        .appendTo('body')
    ;

    var $clientname = $('#client_name');
    var $clientCity = $('#client_city');
    var $clientaddress = $('#client_street');
    var $clientplace = $('#client_place');
    var $clientcontractor = $('#client_contractor_name');
    var $clientcontractorId = $('#client_contractor_id');

    var makeSuggestList = function (data, offset) {
        if ($('.suggest').length == 0) {
            $suggest = $('<ul>');

            $suggest
                .addClass('suggest')
                .appendTo('body')
            ;
        }

        $suggest.children().remove();
        $suggest.css({'display': 'block'}).offset({left: offset.left, top: offset.top + 26});

        for (var i = 0; i < data.length; i++) {
            var $li = $('<li>')
                .attr({
                    'data-id': data[i].id,
                    'data-name': data[i].name,
                    'data-address': data[i].address,
                    'data-inn': data[i].inn
                })
                .on('click', function () {
                    if (suggestField == 'client_contractor_name') {
                        $clientcontractor.val($(this).attr('data-name'));
                        $clientcontractorId.val($(this).attr('data-id'));

                        // Сохранение карточки клиента
                        $('#button-save').click();

                    } else if (suggestField = 'client_street') {
                        $clientplace.val($(this).attr('data-id'));
                        $clientaddress.val($(this).attr('data-name'));
                        $clientaddress.data('street', $(this).attr('data-id'));
                        if (newClient) {
                            getSimilarClients();
                        }
                    } else {
                        $clientname.val($(this).attr('data-name'));
                        $clientplace.val($(this).attr('data-id'));
                        $clientaddress.val($(this).attr('data-name'));
                    }

                    $suggest.css({'display': 'none'});
                });

            if (suggestField == 'client_contractor_name') {
                if (data[i].inn) {
                    $li.text(data[i].name + ' (ИНН: ' + data[i].inn + ')');
                } else {
                    $li.text(data[i].name);
                }
            } else if (data[i].address) {
                $li.text(data[i].name + ' (' + data[i].address + ')');
            } else {
                $li.text(data[i].name);
            }

            $li.appendTo($suggest);
        }
    };

    var ajaxSuggest = function () {

        var search = $(this).val();
        var offset = $(this).offset();

        suggestField = $(this).attr('id');

        if (search) {
            $.ajax({
                'url': $(this).attr('data-url'),
                'data': {
                    'city': $clientCity.val(),
                    'text': search
                },
                'success': function (data) {
                    makeSuggestList(data, offset);
                }
            });
        } else {
            $suggest.css({'display': 'none'});
        }

    };

    var placeSuggest = function () {
        $clientaddress.on('keyup.suggest', ajaxSuggest);
        $clientcontractor.on('keyup.suggest', ajaxSuggest);

        $clientaddress.on('focusin.suggest', ajaxSuggest);
        $clientcontractor.on('focusin.suggest', ajaxSuggest);
    };

    $clientname.closest('form').find('input, textarea').on('focusin', function (event) {
        setTimeout(function () {
            $suggest.css({'display': 'none'});
        }, 25);
    });

    $('#client_type').each(placeSuggest).on('change', placeSuggest);

    if ($('#comments').length > 0) {
        $('div#comments ul.comment-action li').on('click', function (event) {
            event.preventDefault();
            var $element = $(this);

            $('div#comments ul.comment-action li').removeClass('active');
            $element.addClass('active');

            $('#client_newComment_action input[value=' + $(event.target).data('id') + ']').prop('checked', 'checked');

            if ($element.attr('id') == 'comment-postpone-button') {
                $("#comment-postpone-datepicker").show();
            } else {
                $("#comment-postpone-datepicker").hide();
            }
        });
    }

    // Кнопка установки главного клиента ресторанной группы
    $('button#client_setRestaurantGroupMainClient').on('click', function (event) {
        var $this = $(this),
            $parentSpan = $this.parent('span');
        $.ajax({
            'url': $parentSpan.data('url'),
            'success': function (data) {
                if (data == true) {
                    $this.hide();
                    $('div#restaurant-group-main-client').show();
                    $('a.open-client-window').parent('span').html($parentSpan.data('current-client'));
                }
            }
        });
    });

    // Открытие формы добавления напоминания
    $('#client_notificationButton').on('click', function () {
        $('#create-notification').show();
        $('#create-editor-task').hide();
    });

    $("#pays_tabs").tabs(
        {
            active: 0
        }
    );

    var $cashPayments = $("#cash-payment");

    $cashPayments.find("button").on('click', function (e) {
        e.preventDefault();

        var sum = $cashPayments.find('input').val();
        var url = $(this).data('url');

        $.post(url, {sum: sum}, function (data) {
            if (data.success) {
                $cashPayments.find('input').val("");
                alert('Ваш платеж отправлен на модерацию, попросите руководителя одобрить');
            } else {
                if (data.error !== undefined) {
                    alert(data.error);
                } else {
                    alert('Ошибка добавления')
                }
            }
        });
    });

    var $fictitiousPayments = $("#fictitious-payment");

    $fictitiousPayments.find("button").on('click', function (e) {
        e.preventDefault();

        var sum = $fictitiousPayments.find('input').val();
        var url = $(this).data('url');

        $.post(url, {sum: sum}, function (data) {
            if (data.success) {
                $fictitiousPayments.find('input').val("");

                $("#users-dialog")
                    .html(`<div class="fictitious-success">Создан фиктивный платеж на сумму ${sum} рублей</div>`)
                    .dialog({
                        modal:true,
                        width: 300,
                        height:300,
                        zIndex:200,
                        buttons: [
                            {
                                text: "Закрыть",
                                icons: {
                                    primary: "ui-icon-close"
                                },
                                click: function() {
                                    $(this).dialog('close');
                                }
                            }
                        ]
                    });
            } else {
                if (data.error !== undefined) {
                    alert(data.error);
                } else {
                    alert('Ошибка добавления')
                }
            }
        });
    });
};

$(function () {
    $("button.service-stop").on('click', function () {
        if (confirm('Вы уверены, что этот клиент вам уже не заплатит за эту услугу?')) {
            var $button = $(this);
            var id = $button.data('id');
            $.post(Routing.generate('app_service_servicerest_stopservice', {id: id}), function (data) {
                if (data.success) {
                    window.location.reload(true);
                } else {
                    alert('Ошибка!');
                }
            });
        }
    });

    $("button.service-stop-debt").on('click', function () {
        if (confirm('Вы уверены, что хотите погасить долг и перенести услугу в архив?')) {
            var $button = $(this);
            var serviceId = $button.data('id');
            var $select = $button.prevAll('select');
            var transactionId = $select.val();
            $.post(
                Routing.generate('app_service_servicerest_stopservice', {id: serviceId}),
                {transactionId: transactionId, debt: true},
                function (data) {
                    if (data.success) {
                        window.location.reload(true);
                    } else if (data.error) {
                        alert(data.error);
                    } else {
                        alert('Ошибка!');
                    }
                });
        }
    });

    $("button.service-suspend").on('click', function (e) {
        e.preventDefault();
        if (confirm('Эта функция приостановит оказание услуг и заморозит деньги на счету клиента. ВЫ УВЕРЕНЫ?')) {
            var $button = $(this);
            var id = $button.data('id');
            $("button.service-suspend").off('click');
            $.post(Routing.generate('app_service_servicerest_suspendservice', {id: id}), function (data) {
                if (data.success) {
                    window.location.reload(true);
                } else {
                    alert('Ошибка!');
                }
            });
        }
    });

    $("body").on('click','a.client-service-history-slave._link', function (event) {
        event.preventDefault();
        const block = $(this).parent();
        const description = block.find("._description");
        alert(description.html());
    });

    $("body").on('click','a.service-history-link', function (event) {
        event.preventDefault();
        const link = $(this).attr('href');
        $.get(link, function (data) {
            if (data.success && data.html) {
                $("#users-dialog")
                    .html(data.html)
                    .dialog({
                        modal:true,
                        width: 900,
                        height:600,
                        zIndex:200,
                        buttons: [
                            {
                                text: "Закрыть",
                                icons: {
                                    primary: "ui-icon-close"
                                },
                                click: function() {
                                    $(this).dialog('close');
                                }
                            }
                        ]
                    });
            } else {

            }
        });
        $(".client-service-history-slave").tooltip();
    });

    $("body").on('click','a.service-paid-history-link', function (event) {
        event.preventDefault();
        const link = $(this).attr('href');
        $.get(link, function (data) {
            if (data.success && data.html) {
                $("#users-dialog")
                    .html(data.html)
                    .dialog({
                        modal:true,
                        width: 450,
                        height:600,
                        zIndex:200,
                        buttons: [
                            {
                                text: "Закрыть",
                                icons: {
                                    primary: "ui-icon-close"
                                },
                                click: function() {
                                    $(this).dialog('close');
                                }
                            }
                        ]
                    });
            } else {

            }
        });
        $(".client-service-history-slave").tooltip();
    });

    (function handlerServiceRestart() {
        $("button.service-restart").on('click', function (e) {
            e.preventDefault();

            var button             = $(this);
            var serviceId          = button.data('id');
            var noTransactions     = button.data('notransactions');
            var serviceBalance     = button.data('balance');
            var parent             = this.parentNode;

            var writeOffSizeEl     = parent.querySelector('input[name="writeOffSize"]');
            var writeOffSize       = parseFloat($(writeOffSizeEl).val() || 0);

            var parsed             = parent.querySelector('select.parsed');
            var transactionId      = $(parsed).val();

            if ((serviceBalance <= 0 || noTransactions) && transactionId == null) {
                alert('Ошибка: Платёж не выбран!');
                console.log('Stop conditions: 0');
                return;
            }

            if (serviceBalance <= 0) {
                var transactionDeposit = $(`option[value=${transactionId}]`).data('deposit');

                if (writeOffSize > transactionDeposit) {
                    alert('Ошибка: Сумма списания превышает размер выбранного платежа!');
                    console.log('Stop conditions: 1');
                    return;
                }

                if (writeOffSize == 0 && !confirm('Предупреждение: Внести всю сумму платежа на баланс услуги?')) {
                    console.log('Stop conditions: 2');
                    return;
                }
            }

            if (confirm('Включить услугу с сегодняшнего числа?')) {
                $("button.service-restart").off('click');
                $.post(
                    Routing.generate('app_service_servicerest_restartservice', {id: serviceId}),
                    {
                        transactionId: transactionId,
                        writeOffSize: writeOffSize,
                    },
                    function (data) {
                        if (data.success) {
                            window.location.reload(true);
                        } else if (data.error) {
                            alert(data.error);
                            handlerServiceRestart();
                        } else {
                            alert('Ошибка!');
                        }
                    }
                );
            }
        });
    })();

    $("button.service-notification").on('click', function () {
        if (confirm('Отправить уведомление о приостановке услуги?')) {
            var $button = $(this);
            var serviceId = $button.data('id');
            $.post(
                Routing.generate('app_service_servicerest_notificationclient', {id: serviceId}),
                {},
                function (data) {
                    if (data.success) {
                        alert('Сообщение отправленно');
                        window.location.reload(true);
                    } else if (data.error) {
                        alert(data.error);
                    } else {
                        alert('Ошибка!');
                    }
                });
        }
    });

    $("span.remove-gift").on('click', function () {
        var $e = $(this);
        if (confirm('Убрать подарок: ' + $e.text(), '?')) {
            $.post(
                Routing.generate(
                    'app_service_servicerest_removegiftservice',
                    {
                        'clientService': $e.data('client-service-id'),
                        'service': $e.data('service-id')
                    }
                ),
                {},
                function (data) {
                    if (data.success) {
                        alert('Подарок удалён');

                        window.location.reload();
                    } else if (data.error) {
                        alert(data.error);
                    }
                });
        }
    })
});
